import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";

export const EntrataCredentialForm = ({ register }: CredentialFormProps) => (
  <>
    <BaseInput
      id="entrata_domain"
      label="Domain"
      {...register("entrata_domain")}
      required
    />
    <BaseInput
      id="entrata_username"
      label="Username"
      {...register("entrata_username")}
    />
    <BaseInput
      id="entrata_password"
      label="Password"
      {...register("entrata_password")}
    />
    <BaseInput
      id="entrata_mfa_email"
      label="MFA Email"
      {...register("entrata_mfa_email")}
    />
  </>
);
